module.exports = __webpack_public_path__ + "static/img/car_2.ee6a91a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/image/car_2.png
// module id = 0q08
// module chunks = 1